import {HttpClient} from '@angular/common/http';
import {ParentAPIService} from './parent.api.service';
import {Injectable} from '@angular/core';
import {CrystalclearBackUrl} from './config/crystalclear-back-url';
import {BehaviorSubject, Subscription, timer} from 'rxjs';
import {CrystalclearHealth} from '../model/crystalclear-health';
import {timeout} from 'rxjs/operators';
import {CrystalclearToolsBackUrl} from "./config/crystalclear-tools-back-url";
import {ServiceHealthState} from "../model/tools/service-health-state";
import TYPE = ServiceHealthState.TYPE;

@Injectable({
  providedIn: 'root'
})

export class CrystalAvailabilityService extends ParentAPIService {

  isCrystalClearAvailableEmitter: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  isCrystalClearHubServiceAvailableEmitter: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  isCrystalClearArchiveServiceAvailableEmitter: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  private isChecking: boolean | undefined;
  private subscription: Subscription = new Subscription();

  constructor(http: HttpClient) {
    super(http);
    this.isCrystalClearAvailableEmitter.subscribe(isAvailable => {
      if (isAvailable) {
        this.subscription.unsubscribe();
      }
    });
  }

  public checkAvailability() {
    if (this.isChecking) {
      return;
    }
    this.isChecking = true;
    this.isCrystalClearAvailableEmitter.next(false);
    const time = timer(0, 5000);
    this.subscription = time.subscribe(() => this.get<CrystalclearHealth>(CrystalclearBackUrl.GET_CRYSTALCLEAR_HEALTH)
      .pipe(timeout(10000)).subscribe(health => {
        console.log("checkAvailability " + health);
        this.isCrystalClearAvailableEmitter.next(health.status === 'UP');
        this.isChecking = health.status !== 'UP';
      }));
  }

  checkServicesAvailability() {
    if (this.isChecking) {
      return;
    }
    this.isChecking = true;
    // this.isCrystalClearHubServiceAvailableEmitter.next(false);
    // this.isCrystalClearArchiveServiceAvailableEmitter.next(false);
    const time = timer(0, 5000);
    this.subscription = time.subscribe(() => this.get(CrystalclearToolsBackUrl.GET_SERVICES_HEALTH)
      .pipe(timeout(10000)).subscribe(health => {
        console.log("checkAvailability " + health);
        let state: ServiceHealthState = health.item.find(serviceHealthState => serviceHealthState.type == TYPE.HUB);
        const hubRunning = state ? state.running : false;
        state = health.item.find(serviceHealthState => serviceHealthState.type == TYPE.ARCHIVE);
        const archiveRunning = state ? state.running : false;
        this.isCrystalClearHubServiceAvailableEmitter.next(hubRunning);
        this.isCrystalClearArchiveServiceAvailableEmitter.next(archiveRunning);
        this.isChecking = !hubRunning || !archiveRunning;
      }));
  }
}
